import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faUserSlash } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Checkbox, ListItem, Text, UserProfileImage,
} from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import { TaskListItemModel } from '@domain-group/realhub-backend-api-types'

import useTaskListItem, { useRelations } from '@hooks/useTaskListItem'
import { useRelations as useUserRelations } from '@hooks/useUser'

interface SubTaskProps {
  taskListItem: TaskListItemModel,
}

const SubTask = (props: SubTaskProps) => {
  const { taskListItem } = props

  const taskListItemPayload = useTaskListItem(taskListItem)
  const {
    callbacks: { createOrEditTaskListItem },
    taskListItem: { completed, title },
  } = taskListItemPayload

  const { assignee } = useRelations(taskListItem)
  const { image } = useUserRelations(assignee)

  const completionDate = digObject(taskListItem, 'dates.complete.date_time')

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        as: 'a',
        borderBottom: '1px dashed',
        fontSize: 'small',
        padding: 'large',
      }}
      onClick={() => createOrEditTaskListItem()}
      showAngleIcon
    >
      <Checkbox
        checked={completed}
        fontSize="small"
      />

      <Box alignItems="center" maxWidth="calc(100% - 30px)">
        <Box flexDirection="column" maxWidth="80%" paddingRight="large">
          <Text variant="ellipsis">{title}</Text>

          {completed && (
            <Text
              color="bodyFontLightColor"
              display={['none', 'block']}
              fontSize="xsmall"
              marginTop="small"
              variant="ellipsis"
            >
              Completed at {completionDate}
            </Text>
          )}
        </Box>

        <Box maxWidth="40%" overflow="hidden" justifyContent="flex-end">
          <Box marginLeft="auto" width="auto">
            <UserProfileImage
              boxProps={{ display: 'inline-flex' }}
              hintComponent={(
                <UserProfileImage.Hint>
                  {/*
                   // @ts-expect-error TS2339 */}
                  {assignee.full_name || 'Unassigned'}
                </UserProfileImage.Hint>
              )}
              imageUrl={image.thumb_url}
            >
              {/*
               // @ts-expect-error TS2339 */}
              <FontAwesomeIcon icon={assignee.id ? faUser : faUserSlash} />
            </UserProfileImage>
          </Box>
        </Box>
      </Box>
    </ListItem>
  )
}

export default SubTask
